/**
 * Annalise Paints – Cart Drawer
 * All thresholds, variant IDs, and text driven by section settings.
 * Edit via Shopify Admin > Online Store > Themes > Customize > Cart Drawer
 */

const CD_CONFIG = {
  PROTECTION_VID:   47601097113652,
  PROTECTION_PRICE: 295,
  GIFT_VIDS:        [],
  FREE_SHIPPING:    12000,
  FLAT_SHIPPING:    795,
  TIMER_MINS:       15,
  SHOW_FBT:         true,
  IMAGE_SIZE:       64,
  TIERS:            [],
  FBT_COUNT:        3,
  FBT_INTENT:       'related',
  BTN_TEXT:         'Checkout \u2022 {total}',
  SHOP_URL:         '/collections/all',
};

(function() {
  var s = window.cdSectionSettings;
  if (!s) return;
  if (s.flatShippingCents) CD_CONFIG.FLAT_SHIPPING = parseInt(s.flatShippingCents, 10);
  if (s.timerMinutes)      CD_CONFIG.TIMER_MINS    = parseInt(s.timerMinutes, 10);
  if (s.showFBT === false) CD_CONFIG.SHOW_FBT      = false;
  if (s.imageSize)         CD_CONFIG.IMAGE_SIZE    = parseInt(s.imageSize, 10);
  if (s.tiers && s.tiers.length) {
    CD_CONFIG.GIFT_VIDS = s.tiers
      .map(function(t) { return parseInt(t.freeVariantId, 10); })
      .filter(function(id) { return id > 0; });
    var shippingTier = s.tiers.find(function(t) { return parseInt(t.freeVariantId, 10) === 0; });
    if (shippingTier) CD_CONFIG.FREE_SHIPPING = parseInt(shippingTier.threshold, 10);
    CD_CONFIG.TIERS = s.tiers.map(function(t) {
      return {
        threshold:     parseInt(t.threshold, 10),
        title:         t.title,
        icon:          t.icon || '\uD83C\uDF81',
        imageUrl:      t.imageUrl || '',
        freeVariantId: parseInt(t.freeVariantId, 10) || 0,
        preMsg:        function(r) { return 'You\'re <strong>' + r + '</strong> away from <strong>' + t.title + '</strong>'; },
        unlockedMsg:   '<strong>' + t.title + '</strong> unlocked \uD83C\uDF89',
      };
    });
  }
})();

class CartDrawer {
  constructor() {
    this.drawer     = document.getElementById('cart-drawer');
    this.overlay    = document.getElementById('cart-drawer-overlay');
    this.closeBtn   = document.getElementById('cart-drawer-close');
    this.itemsEl    = document.getElementById('cart-items-container');
    this.footerEl   = document.getElementById('cart-drawer-footer');
    this.subtotalEl = document.getElementById('cart-subtotal-price');
    this.checkoutEl = document.getElementById('cart-checkout-text');
    this.discWrap   = document.getElementById('cart-discounts');
    this.discInner  = document.getElementById('cart-discounts-inner');
    this.protToggle = document.getElementById('shipping-protection-toggle');
    this.fbtList    = document.getElementById('cart-fbt-list');
    this.progMsg    = document.getElementById('cart-progress-message');
    this.progFill   = document.getElementById('cart-progress-fill');
    this.progTrack  = document.getElementById('cart-progress-track');
    this.progMiles  = document.getElementById('cart-progress-milestones');

    this.cart          = null;
    this.isOpen        = false;
    this.lastPid       = null;
    this._fbtCache     = {};
    this._fbtFetch     = {};
    this._timerRunning = false;
    this._qtyDebounce  = {};
    this._giftQueue    = [];
    this._giftRunning  = false;

    this._init();
  }

  _init() {
    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && this.isOpen) this.close(); });

    this.itemsEl?.addEventListener('click', e => {
      const rm = e.target.closest('.cd-item__remove');
      if (rm) { e.stopPropagation(); this._removeItem(rm.dataset.key); return; }
      const qb = e.target.closest('[data-action]');
      if (qb) {
        e.stopPropagation();
        const { key, action } = qb.dataset;
        const item = this.cart?.items.find(i => i.key === key);
        if (!item || this._isGift(item.variant_id)) return;
        if (action === 'decrease' && item.quantity <= 1) { this._removeItem(key); return; }
        this._changeQty(key, action === 'increase' ? item.quantity + 1 : item.quantity - 1);
      }
    });

    this.protToggle?.addEventListener('change', () => this._toggleProtection(this.protToggle.checked));
    document.addEventListener('cart:refresh', () => this._fetchAndRender());
    this._buildMilestones();
    this._fetchAndRender();

    // Hide FBT section immediately if disabled
    if (!CD_CONFIG.SHOW_FBT) {
      const fbt = document.getElementById('cart-fbt-section');
      if (fbt) fbt.style.display = 'none';
    }

    const claim = () => {
      ['#cart-icon-bubble', '.header__icon--cart', 'a[href="/cart"]'].forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
          if (el.dataset.cdClaimed) return;
          el.dataset.cdClaimed = '1';
          el.addEventListener('mouseenter', () => this._prefetchFBT(), { passive: true });
          el.addEventListener('click', e => { e.preventDefault(); e.stopImmediatePropagation(); window.cartDrawer?.open(); }, true);
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', claim);
    else claim();
    setTimeout(claim, 600);
    setTimeout(() => this._prefetchFBT(), 1000);
  }

  open() {
    this.isOpen = true;
    this.drawer.classList.add('is-open');
    this.overlay.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    this.closeBtn?.focus();
    this._fetchAndRender();
  }

  close() {
    this.isOpen = false;
    this.drawer.classList.remove('is-open');
    this.overlay.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    this.overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  _isGift(vid) { return CD_CONFIG.GIFT_VIDS.indexOf(parseInt(vid, 10)) !== -1; }

  _spend(items) {
    return items.reduce((s, i) => {
      if (i.variant_id === CD_CONFIG.PROTECTION_VID) return s;
      if (this._isGift(i.variant_id)) return s;
      return s + i.final_line_price;
    }, 0);
  }

  _changeQty(key, newQty) {
    if (!this.cart) return;
    const idx = this.cart.items.findIndex(i => i.key === key);
    if (idx === -1) return;
    const item = this.cart.items[idx];
    if (this._isGift(item.variant_id)) return;
    newQty = Math.max(1, newQty);
    const newLine = item.final_price * newQty;
    const newOrig = item.original_price * newQty;
    this._patchItemDOM(key, newQty, item, newLine);
    const newItems = this.cart.items.map((i, ix) => ix === idx
      ? { ...i, quantity: newQty, final_line_price: newLine, original_line_price: newOrig } : i);
    this.cart = { ...this.cart, items: newItems, total_price: this._calcTotal(newItems) };
    this._updateFooterTotals();
    this._updateProgress();
    if (this._qtyDebounce[key]?.timer) clearTimeout(this._qtyDebounce[key].timer);
    this._qtyDebounce[key] = {
      pendingQty: newQty,
      timer: setTimeout(() => {
        const finalQty = this._qtyDebounce[key]?.pendingQty ?? newQty;
        delete this._qtyDebounce[key];
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: finalQty }) })
          .then(r => r.json()).then(serverCart => {
            const srv = serverCart.items.find(i => i.key === key);
            if (srv && srv.quantity !== finalQty) { this.cart = serverCart; this._fullRender(serverCart); }
            else { this.cart = serverCart; this._updateFooterTotals(); this._updateProgress(); }
          }).catch(() => this._fetchAndRender());
      }, 400)
    };
  }

  _patchItemDOM(key, newQty, item, newLine) {
    const el = document.getElementById('cart-item-' + key);
    if (!el) return;
    const qv = el.querySelector('.cd-qty__value'); if (qv) qv.textContent = newQty;
    const mn = el.querySelector('.cd-qty__btn--minus'); if (mn) mn.disabled = newQty <= 1;
    const pe = el.querySelector('.cd-item__pricing'); if (!pe) return;
    const compareAt = parseInt(el.dataset.compareAt || '0', 10);
    const wasUnit = (compareAt && compareAt > item.final_price) ? compareAt : item.original_price;
    const lineOrig = wasUnit * newQty;
    const hasDisc = lineOrig > newLine;
    pe.innerHTML = hasDisc
      ? '<span class="cd-item__price cd-item__price--compare">' + this._$$(lineOrig) + '</span><span class="cd-item__price cd-item__price--sale">' + this._$$(newLine) + '</span><span class="cd-item__savings">Save ' + this._$$(lineOrig - newLine) + '</span>'
      : '<span class="cd-item__price">' + this._$$(newLine) + '</span>';
  }

  _calcTotal(items) { return items.reduce((s, i) => s + i.final_line_price, 0); }

  _removeItem(key) {
    if (!this.cart) return;
    if (!this.cart.items.find(i => i.key === key)) return;
    const el = document.getElementById('cart-item-' + key);
    if (el) { el.style.transition = 'opacity 0.15s ease, transform 0.15s ease'; el.style.opacity = '0'; el.style.transform = 'translateX(12px)'; }
    this.cart = { ...this.cart, items: this.cart.items.filter(i => i.key !== key) };
    this.cart.total_price = this._calcTotal(this.cart.items);
    this._updateFooterTotals();
    this._updateProgress();
    const visiblePaid = this.cart.items.filter(i => i.variant_id !== CD_CONFIG.PROTECTION_VID && !this._isGift(i.variant_id));
    if (visiblePaid.length === 0) { setTimeout(() => this._fullRender(this.cart), 160); }
    else if (el) { setTimeout(() => el.remove(), 160); }
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) })
      .then(r => r.json()).then(cart => {
        this.cart = cart; this._updateFooterTotals(); this._updateProgress();
        this._renderDiscounts(cart);
        this._renderProtection(cart.items.some(i => i.variant_id === CD_CONFIG.PROTECTION_VID));
      }).catch(() => this._fetchAndRender());
  }

  _toggleProtection(enable) {
    if (!this.cart) return;
    const vid = CD_CONFIG.PROTECTION_VID, p = CD_CONFIG.PROTECTION_PRICE;
    if (enable) {
      this.cart = { ...this.cart, total_price: this.cart.total_price + p, items: [...this.cart.items, { variant_id: vid, key: 'prot-opt', final_line_price: p, original_line_price: p, final_price: p, original_price: p, quantity: 1 }] };
    } else {
      this.cart = { ...this.cart, total_price: Math.max(0, this.cart.total_price - p), items: this.cart.items.filter(i => i.variant_id !== vid) };
    }
    this._updateFooterTotals();
    const api = enable
      ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) })
      : (async () => { const c = await (await fetch('/cart.js')).json(); const it = c.items.find(i => i.variant_id === vid); if (it) return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: it.key, quantity: 0 }) }); })();
    api.then(() => fetch('/cart.js')).then(r => r.json()).then(cart => { this.cart = cart; this._updateFooterTotals(); })
      .catch(() => { if (this.protToggle) this.protToggle.checked = !enable; this._fetchAndRender(); });
  }

  async _fetchAndRender() {
    try { const cart = await (await fetch('/cart.js')).json(); this.cart = cart; this._fullRender(cart); }
    catch (e) { console.error('[CartDrawer]', e); }
  }

  _fullRender(cart) {
    const all = cart.items.filter(i => i.variant_id !== CD_CONFIG.PROTECTION_VID);
    const paid = all.filter(i => !this._isGift(i.variant_id));
    this._renderItemsList(all);
    this._renderProtection(cart.items.some(i => i.variant_id === CD_CONFIG.PROTECTION_VID));
    this._renderDiscounts(cart);
    this._updateFooterTotals();
    this._updateProgress();
    if (!CD_CONFIG.SHOW_FBT) {
      const fbt = document.getElementById('cart-fbt-section');
      if (fbt) fbt.style.display = 'none';
      return;
    }
    if (paid.length > 0) {
      const pid = paid[paid.length - 1].product_id;
      if (pid !== this.lastPid) { this.lastPid = pid; this._prefetchFBTProduct(pid); }
      this._loadFBT(pid);
    } else {
      if (this.fbtList) this.fbtList.innerHTML = '';
      const s = document.getElementById('cart-fbt-section'); if (s) s.style.display = 'none';
    }
  }

  _renderItemsList(items) {
    if (!this.itemsEl) return;
    const protEl = document.getElementById('cart-shipping-protection');
    const fbtEl  = document.getElementById('cart-fbt-section');
    const paid   = items.filter(i => !this._isGift(i.variant_id));
    if (paid.length === 0 && items.length === 0) {
      this.itemsEl.innerHTML = this._emptyHTML();
      [protEl, fbtEl, this.footerEl].forEach(el => { if (el) el.style.display = 'none'; });
      return;
    }
    [protEl, this.footerEl].forEach(el => { if (el) el.style.display = ''; });
    if (fbtEl) fbtEl.style.display = CD_CONFIG.SHOW_FBT ? '' : 'none';
    this.itemsEl.innerHTML = items.map((item, i) => this._itemHTML(item, i)).join('');
  }

  _updateFooterTotals() {
    if (!this.cart) return;
    const f = this._$$(this.cart.total_price);
    if (this.subtotalEl) this.subtotalEl.textContent = f;
    if (this.checkoutEl) this.checkoutEl.innerHTML = CD_CONFIG.BTN_TEXT.replace('{total}', f);
    const paidItems = (this.cart.items || []).filter(i => i.variant_id !== CD_CONFIG.PROTECTION_VID && !this._isGift(i.variant_id));
    const savingsEl = document.getElementById('cd-savings-line');
    if (savingsEl) {
      const totalWas   = paidItems.reduce((s, i) => s + this._wasPrice(i) * i.quantity, 0);
      const totalFinal = paidItems.reduce((s, i) => s + i.final_line_price, 0);
      const saved = totalWas - totalFinal;
      if (saved > 50) { savingsEl.textContent = 'You\u2019re saving ' + this._$$(saved) + ' today \uD83C\uDF89'; savingsEl.style.display = 'block'; }
      else { savingsEl.style.display = 'none'; }
    }
    const shippingEl = document.getElementById('cd-shipping-msg');
    if (shippingEl) {
      const spend = this._spend(this.cart.items || []);
      if (spend >= CD_CONFIG.FREE_SHIPPING) {
        shippingEl.innerHTML = '&#10003;&nbsp;Free shipping unlocked!';
        shippingEl.style.color = '#BC7D6A'; shippingEl.style.fontWeight = '600';
      } else {
        shippingEl.innerHTML = 'Shipping: <strong>' + this._$$(CD_CONFIG.FLAT_SHIPPING) + '</strong> &mdash; spend <strong>' + this._$$(CD_CONFIG.FREE_SHIPPING - spend) + '</strong> more for free shipping';
        shippingEl.style.color = '#7A6760'; shippingEl.style.fontWeight = '400';
      }
    }
    const bar = document.getElementById('cd-reservation-bar');
    if (bar) {
      if (paidItems.length > 0 && bar.style.display !== 'flex') { bar.style.display = 'flex'; this._startTimer(); }
      else if (paidItems.length === 0) { bar.style.display = 'none'; }
    }
  }

  _wasPrice(item) {
    const vid = String(item.variant_id);
    const liq = window.__cdCompareAt && window.__cdCompareAt[vid];
    if (liq && liq > item.final_price) return liq;
    if (item.compare_at_price && item.compare_at_price > item.final_price) return item.compare_at_price;
    if (item.original_price && item.original_price > item.final_price) return item.original_price;
    return item.final_price;
  }

  _updateProgress() {
    if (!CD_CONFIG.TIERS.length || !this.cart) return;
    const tiers = CD_CONFIG.TIERS, maxTier = tiers[tiers.length - 1];
    const spend = this._spend(this.cart.items || []);
    const pct = Math.min(100, (spend / maxTier.threshold) * 100);
    if (this.progFill) this.progFill.style.setProperty('width', pct.toFixed(2) + '%', 'important');
    if (this.progTrack) this.progTrack.setAttribute('aria-valuenow', Math.round(pct));
    document.querySelectorAll('.cd-milestone').forEach(m => {
      const t = parseInt(m.dataset.threshold, 10), u = spend >= t;
      const ic = m.querySelector('.cd-milestone__icon'), lb = m.querySelector('.cd-milestone__label');
      if (ic) { ic.style.borderColor = u ? '#BC7D6A' : '#D9C8C3'; ic.style.boxShadow = u ? '0 2px 8px rgba(188,125,106,0.5)' : '0 2px 6px rgba(44,31,26,0.14)'; }
      if (lb) { lb.style.color = u ? '#BC7D6A' : '#7A6760'; lb.style.fontWeight = u ? '700' : '600'; }
    });
    tiers.forEach(t => {
      if (!t.freeVariantId) return;
      const unlocked = spend >= t.threshold;
      const inCart   = (this.cart.items || []).some(i => i.variant_id === t.freeVariantId);
      if (unlocked && !inCart)   this._enqueueGift('add', t.freeVariantId);
      if (!unlocked && inCart) { const it = (this.cart.items || []).find(i => i.variant_id === t.freeVariantId); if (it) this._enqueueGift('remove', t.freeVariantId, it.key); }
    });

    // Single-line message: "[unlocked msg] — You're $X away from [next]"
    let msg = '', hi = false;
    if (spend >= maxTier.threshold) {
      msg = '\uD83C\uDF89 All rewards unlocked \u2014 you\'re amazing!'; hi = true;
    } else {
      for (let i = 0; i < tiers.length; i++) {
        if (spend < tiers[i].threshold) {
          const rem = tiers[i].threshold - spend;
          if (i > 0 && spend >= tiers[i - 1].threshold) {
            // Show unlocked + next on same line
            hi = true;
            msg = tiers[i - 1].unlockedMsg + ' \u2014 ' + tiers[i].preMsg(this._$$(rem)) + '!';
          } else {
            msg = tiers[i].preMsg(this._$$(rem)) + '!';
          }
          break;
        }
      }
    }
    if (this.progMsg) {
      this.progMsg.innerHTML = msg;
      this.progMsg.style.color = hi ? '#BC7D6A' : '#2C1F1A';
    }
  }

  _enqueueGift(action, variantId, key) {
    const already = this._giftQueue.some(q => q.action === action && q.variantId === variantId);
    if (already) return;
    const oppositeIdx = this._giftQueue.findIndex(q => q.action !== action && q.variantId === variantId);
    if (oppositeIdx !== -1) { this._giftQueue.splice(oppositeIdx, 1); return; }
    this._giftQueue.push({ action, variantId, key });
    this._processGiftQueue();
  }

  async _processGiftQueue() {
    if (this._giftRunning || this._giftQueue.length === 0) return;
    this._giftRunning = true;
    const job = this._giftQueue.shift();
    try {
      if (job.action === 'add') await this._doAddGift(job.variantId);
      else await this._doRemoveGift(job.variantId, job.key);
    } catch (e) { console.error('[CD] gift queue error', e); }
    finally { this._giftRunning = false; if (this._giftQueue.length > 0) this._processGiftQueue(); }
  }

  async _doAddGift(variantId) {
    const fresh = await (await fetch('/cart.js')).json();
    if (fresh.items.some(i => i.variant_id === variantId)) { this.cart = fresh; this._fullRender(fresh); return; }
    const addRes = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: 1, properties: { _free_gift: 'true' } }) });
    if (!addRes.ok) throw new Error('add failed');
    const afterAdd = await (await fetch('/cart.js')).json();
    const added = afterAdd.items.find(i => i.variant_id === variantId);
    if (added) await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: added.key, quantity: 1, price: 0 }) });
    const final = await (await fetch('/cart.js')).json();
    this.cart = final; this._fullRender(final);
  }

  async _doRemoveGift(variantId, cachedKey) {
    let key = cachedKey;
    if (!key) {
      const fresh = await (await fetch('/cart.js')).json();
      const item = fresh.items.find(i => i.variant_id === variantId);
      if (!item) { this.cart = fresh; this._fullRender(fresh); return; }
      key = item.key;
    }
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
    const final = await (await fetch('/cart.js')).json();
    this.cart = final; this._fullRender(final);
  }

  _buildMilestones() {
    if (!this.progMiles || !CD_CONFIG.TIERS.length) return;
    const tiers = CD_CONFIG.TIERS, max = tiers[tiers.length - 1].threshold;
    this.progMiles.innerHTML = tiers.map(t => {
      const pct  = (t.threshold / max) * 100;
      const icon = t.imageUrl
        ? '<img src="' + t.imageUrl + '" alt="' + t.title + '" style="width:100%;height:100%;object-fit:cover;border-radius:50%;display:block;">'
        : '<span style="font-size:17px;line-height:1;">' + t.icon + '</span>';
      return '<div class="cd-milestone" data-threshold="' + t.threshold + '" style="position:absolute;top:50%;left:' + pct + '%;transform:translate(-50%,-50%);display:flex;flex-direction:column;align-items:center;">'
        + '<div class="cd-milestone__icon" style="width:38px;height:38px;border-radius:50%;background:#fff;border:2.5px solid #D9C8C3;display:flex;align-items:center;justify-content:center;overflow:hidden;position:relative;z-index:3;box-shadow:0 2px 6px rgba(44,31,26,0.14);flex-shrink:0;">' + icon + '</div>'
        + '<span class="cd-milestone__label" style="position:absolute;top:calc(100% + 7px);font-size:9px;font-weight:600;color:#7A6760;text-align:center;left:50%;transform:translateX(-50%);line-height:1.3;width:60px;white-space:normal;word-wrap:break-word;">' + this._esc(t.title) + '</span>'
        + '</div>';
    }).join('');
  }

  _renderDiscounts(cart) {
    if (!this.discWrap || !this.discInner) return;
    const codes = cart.cart_level_discount_applications || [];
    if (!codes.length) { this.discWrap.style.display = 'none'; return; }
    this.discWrap.style.display = '';
    this.discInner.innerHTML = codes.map(d => '<span class="cd-discount-badge">' + this._esc(d.title) + '<span class="cd-discount-badge__amount">&minus;' + this._$$(d.total_allocated_amount) + '</span></span>').join('');
  }

  _renderProtection(active) { if (this.protToggle) this.protToggle.checked = active; }

  _startTimer() {
    if (this._timerRunning) return;
    this._timerRunning = true;
    const KEY = 'cd_res_exp', MINS = CD_CONFIG.TIMER_MINS;
    let expiry = parseInt(sessionStorage.getItem(KEY) || '0', 10);
    if (!expiry || expiry < Date.now()) { expiry = Date.now() + MINS * 60000; sessionStorage.setItem(KEY, expiry); }
    const display = document.getElementById('cd-timer-display');
    const tick = () => {
      const rem = expiry - Date.now();
      if (rem <= 0) { expiry = Date.now() + MINS * 60000; sessionStorage.setItem(KEY, expiry); }
      if (display) { const m = Math.floor(rem / 60000), s = Math.floor((rem % 60000) / 1000); display.textContent = m + ':' + (s < 10 ? '0' : '') + s; }
    };
    tick(); setInterval(tick, 1000);
  }

  _itemHTML(item, idx) {
    idx = idx || 0;
    const isGift   = this._isGift(item.variant_id);
    const wasUnit  = this._wasPrice(item);
    const lineFin  = item.final_line_price;
    const lineOrig = wasUnit * item.quantity;
    const hasDisc  = !isGift && lineOrig > lineFin;
    const sz       = CD_CONFIG.IMAGE_SIZE;
    const imgSrc   = item.image ? item.image.replace(/(\.[\w]+)$/, '_' + sz + 'x' + sz + '$1') : null;
    const noDef    = !item.variant_title || item.variant_title === 'Default Title';
    const tags     = !isGift ? (item.discounts || []).map(d => '<li class="cd-item__discount-tag"><svg width="11" height="11" viewBox="0 0 13 13" fill="none"><path d="M1 1h5.5l5.5 5.5-5 5L1.5 6V1H1z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><circle cx="4" cy="4" r="1" fill="currentColor"/></svg>' + d.title + '</li>').join('') : '';
    const pricing  = isGift
      ? (wasUnit > 0 ? '<span class="cd-item__price cd-item__price--compare">' + this._$$(wasUnit) + '</span>' : '') + '<span class="cd-item__price cd-item__price--free">Free</span>'
      : hasDisc
        ? '<span class="cd-item__price cd-item__price--compare">' + this._$$(lineOrig) + '</span><span class="cd-item__price cd-item__price--sale">' + this._$$(lineFin) + '</span><span class="cd-item__savings">Save ' + this._$$(lineOrig - lineFin) + '</span>'
        : '<span class="cd-item__price">' + this._$$(lineFin) + '</span>';
    const imgHTML  = imgSrc
      ? '<img src="' + imgSrc + '" alt="' + this._esc(item.title) + '" class="cd-item__image" width="' + sz + '" height="' + sz + '" loading="' + (idx < 2 ? 'eager' : 'lazy') + '">'
      : '<div class="cd-item__image cd-item__image--placeholder"></div>';
    const actionsHTML = !isGift
      ? '<div class="cd-item__actions"><div class="cd-qty" data-key="' + item.key + '">'
        + '<button class="cd-qty__btn cd-qty__btn--minus" type="button" data-action="decrease" data-key="' + item.key + '"' + (item.quantity <= 1 ? ' disabled' : '') + '><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 7h12" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg></button>'
        + '<span class="cd-qty__value">' + item.quantity + '</span>'
        + '<button class="cd-qty__btn cd-qty__btn--plus" type="button" data-action="increase" data-key="' + item.key + '"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg></button>'
        + '</div><button class="cd-item__remove" type="button" data-key="' + item.key + '" aria-label="Remove ' + this._esc(item.product_title) + '"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2 4h12M5 4V3a1 1 0 011-1h4a1 1 0 011 1v1M6 7v5M10 7v5M3 4l1 9a1 1 0 001 1h6a1 1 0 001-1l1-9" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>'
      : '';
    return '<div class="cd-item' + (isGift ? ' cd-item--gift' : '') + '" id="cart-item-' + item.key + '" data-key="' + item.key + '" data-variant-id="' + item.variant_id + '" data-compare-at="' + wasUnit + '">'
      + '<a href="' + (item.url || '#') + '" class="cd-item__image-link" tabindex="-1" aria-hidden="true">'
      + '<div class="cd-item__image-wrap" style="width:' + sz + 'px;height:' + sz + 'px;">' + imgHTML + '</div></a>'
      + '<div class="cd-item__details">'
      + (isGift ? '<span class="cd-item__gift-badge">\uD83C\uDF81 Gift unlocked</span>' : '')
      + '<a href="' + (item.url || '#') + '" class="cd-item__title">' + this._esc(item.product_title) + '</a>'
      + (!noDef ? '<p class="cd-item__variant">' + this._esc(item.variant_title) + '</p>' : '')
      + '<div class="cd-item__pricing">' + pricing + '</div>'
      + (tags ? '<ul class="cd-item__discounts">' + tags + '</ul>' : '')
      + actionsHTML + '</div></div>';
  }

  _emptyHTML() {
    return '<div class="cd-empty"><div class="cd-empty__illustration"><svg width="80" height="80" viewBox="0 0 80 80" fill="none"><circle cx="40" cy="40" r="38" stroke="#E8D5D0" stroke-width="2"/><path d="M24 28h4l4 20h16l4-16H30" stroke="#BC7D6A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="36" cy="52" r="2" fill="#BC7D6A"/><circle cx="46" cy="52" r="2" fill="#BC7D6A"/><path d="M36 34c0-2.2 1.8-4 4-4s4 1.8 4 4" stroke="#BC7D6A" stroke-width="1.5" stroke-linecap="round"/></svg></div><p class="cd-empty__title">Your cart is empty</p><p class="cd-empty__subtitle">Add something beautiful to get started.</p><a href="' + CD_CONFIG.SHOP_URL + '" class="cd-empty__cta">Shop Now</a></div>';
  }

  async _prefetchFBT() {
    if (!CD_CONFIG.SHOW_FBT) return;
    try { const c = await (await fetch('/cart.js')).json(); const items = c.items.filter(i => !this._isGift(i.variant_id) && i.variant_id !== CD_CONFIG.PROTECTION_VID); if (items.length) this._prefetchFBTProduct(items[items.length - 1].product_id); } catch (e) {}
  }
  async _prefetchFBTProduct(pid) {
    if (this._fbtCache[pid] || this._fbtFetch[pid]) return;
    this._fbtFetch[pid] = true;
    try { this._fbtCache[pid] = await (await fetch('/recommendations/products.json?product_id=' + pid + '&limit=' + CD_CONFIG.FBT_COUNT + '&intent=' + CD_CONFIG.FBT_INTENT)).json(); } catch (e) {} finally { delete this._fbtFetch[pid]; }
  }
  async _loadFBT(pid) {
    if (!CD_CONFIG.SHOW_FBT) return;
    const sec = document.getElementById('cart-fbt-section'); if (!sec || !this.fbtList) return;
    sec.style.display = '';
    if (this._fbtCache[pid]) { this._renderFBT(pid); return; }
    this.fbtList.innerHTML = this._skelHTML();
    if (!this._fbtFetch[pid]) this._prefetchFBTProduct(pid);
    let n = 0; const poll = setInterval(() => { n++; if (this._fbtCache[pid]) { clearInterval(poll); this._renderFBT(pid); } else if (n > 30) { clearInterval(poll); sec.style.display = 'none'; } }, 100);
  }
  _renderFBT(pid) {
    const sec = document.getElementById('cart-fbt-section'), data = this._fbtCache[pid];
    if (!sec || !this.fbtList || !data) return;
    const inCart = new Set((this.cart?.items || []).map(i => i.product_id));
    const recs = (data.products || []).filter(p => !inCart.has(p.id));
    if (!recs.length) { sec.style.display = 'none'; return; }
    this.fbtList.innerHTML = recs.map(p => this._fbtCard(p)).join('');
    this.fbtList.querySelectorAll('[data-fbt-add]').forEach(btn => btn.addEventListener('click', () => this._fbtAdd(btn, parseInt(btn.dataset.fbtAdd, 10))));
  }
  _fbtAdd(btn, vid) {
    btn.disabled = true; btn.textContent = '\u2713 Added'; btn.style.background = '#4CAF50';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) })
      .then(r => { if (!r.ok) throw new Error(); return this._fetchAndRender(); })
      .catch(() => { btn.disabled = false; btn.textContent = 'Add'; btn.style.background = ''; });
  }
  _fbtCard(p) {
    const v = p.variants && p.variants[0]; if (!v) return '';
    const img = p.featured_image ? p.featured_image.replace(/(\.\w+)(\?|$)/, '_120x120$1$2') : null;
    return '<div class="cd-fbt-card">' + (img ? '<img src="' + img + '" alt="' + this._esc(p.title) + '" class="cd-fbt-card__image" width="52" height="52" loading="eager">' : '<div class="cd-fbt-card__image"></div>') + '<div class="cd-fbt-card__info"><p class="cd-fbt-card__title">' + this._esc(p.title) + '</p><p class="cd-fbt-card__price">' + this._$$(parseInt(v.price, 10)) + '</p></div><button class="cd-fbt-card__btn" type="button" data-fbt-add="' + v.id + '">Add</button></div>';
  }
  _skelHTML() {
    return Array(CD_CONFIG.FBT_COUNT).fill(0).map(() => '<div class="cd-fbt-card cd-fbt-card--skeleton"><div class="cd-fbt-skeleton__img"></div><div class="cd-fbt-skeleton__info"><div class="cd-fbt-skeleton__line cd-fbt-skeleton__line--title"></div><div class="cd-fbt-skeleton__line cd-fbt-skeleton__line--price"></div></div><div class="cd-fbt-skeleton__btn"></div></div>').join('');
  }

  _$$(cents) { if (cents == null) return ''; return '$' + (parseInt(cents, 10) / 100).toFixed(2); }
  _esc(s) { if (!s) return ''; return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;'); }
}

document.addEventListener('DOMContentLoaded', () => {
  window.cartDrawer = new CartDrawer();
  document.dispatchEvent(new Event('cartDrawerReady'));
  document.querySelectorAll('a[href="/cart"], [data-cart-drawer-trigger], .header__icon--cart, #cart-icon-bubble').forEach(el => {
    el.addEventListener('click', e => { e.preventDefault(); window.cartDrawer?.open(); });
  });
  document.addEventListener('shopify:cart:add', () => window.cartDrawer?.open());
});
